import {Box, createTheme, CssBaseline, Stack, ThemeProvider, useMediaQuery} from "@mui/material";
import {Route, Routes} from "react-router";
import "@fontsource/poppins";
import {useState} from "react";
import Programs from "../Page/programs";
import InvoicesPage from "../Page/InvoicesPage";
import OrdersPage from "../Page/OrdersPage";
import QuotesPage from "../Page/QuotesPage";
import TicketsPage from "../Page/TicketsPage";
import DemoPage from "../Page/DemoPage";
import AccountPage from "../Page/AccountPage";
import SideBar from "./sidebar/Sidebar";
import Dashboard from "./Dashboard/Dashboard"
import {LayoutDashbordProvider} from "../Context/LayoutDashbordContext";

function Main() {

    // const prefersDarkMode = false;
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const isComputer = useMediaQuery('(min-width:900px)');
    const [sidebarIsOpen, setSidebarIsOpen] = useState();
    const darkTheme = createTheme({

        // direction: 'rtl',
        palette: {
            mode: prefersDarkMode ? 'dark' : 'light',

            background: {
                default: prefersDarkMode ? '#1A1A1A' : '#f5f5f5',
            },

            common: {
                white: {
                    dark: '#cecece'
                },
            },

            greyTimeline: {
                main: '#121212',
            },

            appBackground: {
                main: '#f5f5f5',
                light: '#f5f5f5',
                dark: '#252525'
            },

            reactflowButton: {
                main: '#FFFFFF',
                light: '#FFFFFF',
                dark: '#252525'
            },

            sidebar: {
                dark: '#cecece',
                // dark: '#cecece',
                light: '#616161',
                main: '#616161'
            },

            nodeHandle: {
                dark: '#000000FF',
                light: '#FFFFFF',
                main: '#FFFFFF'
            },

            nodeCard: {
                dark: '#252525',
                light: '#FFFFFF',
                main: '#FFFFFF'
            },

            primary: {
                main: '#FF7233',
                light: '#FF7233',
                // Teinte de survol canonique de la marque (alignée sur le projet mail)
                dark: '#e05a1a',
            },

            // Palette d'accents partagée par les widgets du dashboard (stats, activité, badges)
            stat: {
                blue: '#2196f3',
                green: '#4caf50',
                purple: '#9c27b0',
                red: '#f44336',
                amber: '#FF9800',
            },

        },
        typography: {
            fontFamily: '"Poppins",  sans-serif',
            allVariants: {
                color: prefersDarkMode ? '#cecece' : '#000000FF',
            }
        },
    });


    const getContainerClass = () => {
        let classes = []
        if (!isComputer) {
            classes.push("mobile")
        } else {
            const animation = sidebarIsOpen ? 'activated' : 'disactivated'
            classes.push(animation)
        }

        return classes.join(' ')
    }

    return (
            <ThemeProvider theme={darkTheme}>
                    <SideBar sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} isComputer={isComputer}/>
                    <CssBaseline/>
                    <Stack
                        direction="column"
                        spacing={2}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: '100%'
                        }}
                        minHeight={'100vh'}
                    >

                        <LayoutDashbordProvider>
                        <Box id='Md-Container'  className={getContainerClass()}>
                            <Routes>
                                    <Route exact path="/" element={<Dashboard/>}/>
                                <Route exact path="/programs" element={<Programs/>}/>
                                <Route exact path="/invoices" element={<InvoicesPage/>}/>
                                {/* Commandes/devis temporairement désactivés : backend pas encore en prod */}
                                {/* <Route exact path="/orders" element={<OrdersPage/>}/> */}
                                {/* <Route exact path="/quotes" element={<QuotesPage/>}/> */}
                                <Route exact path="/tickets" element={<TicketsPage/>}/>
                                <Route exact path="/site-internet" element={<DemoPage/>}/>
                                <Route exact path="/account" element={<AccountPage/>}/>
                            </Routes>

                        </Box>

                        </LayoutDashbordProvider>
                    </Stack>
            </ThemeProvider>

    );
}

export default Main;
